import * as Menu from "src/components/ui-components/MenuPanel/MenuPanel";
import { IconTerminalWindow } from "src/components/ui-components/Icons/IconTerminalWindow";
import { IconGridFour } from "src/components/ui-components/Icons/IconGridFour";
import { IconNote } from "src/components/ui-components/Icons/IconNote";
import { IconPeople } from "src/components/ui-components/Icons/IconPeople";
import { IconUploadCloud } from "src/components/ui-components/Icons/IconUploadCloud";
import { IconSparkle } from "src/components/ui-components/Icons/IconSparkle";

import { useMyTeamsIfLoggedIn } from "shared/teams/useMyTeams";
import { useCanInviteMembers } from "src/gql/teams/teams";

import type { Session } from "src/utils/users/types";
import type { ActiveContext } from "shared/ContextSwitcher/store";
import AmplitudeService from "src/services/amplitude";

interface Props {
  session: Session;
  activeContext: ActiveContext;
  setIsCreateDashboardDialogOpen: (open: boolean) => void;
  setIsAddMembersDialogOpen: (open: boolean) => void;
  setIsDataUploadModalOpen: (open: boolean) => void;
  close: () => void;
}

export function HeaderCreateMenu(props: Props) {
  const {
    session,
    activeContext,
    setIsCreateDashboardDialogOpen,
    setIsAddMembersDialogOpen,
    setIsDataUploadModalOpen,
    close,
  } = props;

  const myTeams = useMyTeamsIfLoggedIn(session);
  const canInviteMembers = useCanInviteMembers(activeContext);

  const showCreateTeam = myTeams?.length === 0;

  const renderUploadDatasetButton = () => {
    return (
      <Menu.ItemButton onClick={() => setIsDataUploadModalOpen(true)}>
        <IconUploadCloud />
        Upload a dataset
      </Menu.ItemButton>
    );
  };

  const trackAiClick = () => {
    AmplitudeService.trackEvent("Dune AI Link Clicked", {
      location: "Create Header",
    });
  };

  return (
    <Menu.Panel>
      <Menu.Section>
        <Menu.ItemLink href="/ai" onClick={trackAiClick}>
          <IconSparkle />
          Dune AI
        </Menu.ItemLink>

        <Menu.ItemLink href="/queries">
          <IconTerminalWindow />
          New query
        </Menu.ItemLink>

        <Menu.ItemButton
          onClick={() => {
            setIsCreateDashboardDialogOpen(true);
            close();
          }}
        >
          <IconGridFour />
          New dashboard
        </Menu.ItemButton>
      </Menu.Section>

      <Menu.Section>
        {renderUploadDatasetButton()}

        <Menu.ItemLink href="/contracts/new">
          <IconNote />
          Submit a contract
        </Menu.ItemLink>
      </Menu.Section>

      {(canInviteMembers || showCreateTeam) && (
        <Menu.Section>
          {canInviteMembers && (
            <Menu.ItemButton
              onClick={() => {
                setIsAddMembersDialogOpen(true);
                close();
              }}
            >
              <IconPeople />
              Invite Members
            </Menu.ItemButton>
          )}
          {showCreateTeam && (
            <Menu.ItemLink href="/teams/new">
              <IconPeople />
              Create Team
            </Menu.ItemLink>
          )}
        </Menu.Section>
      )}
    </Menu.Panel>
  );
}
